// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAmUrIHpwtxAA0IrZcamM8wbnNjkwKu2W8",
  authDomain: "newwigo-270d4.firebaseapp.com",
  projectId: "newwigo-270d4",
  storageBucket: "newwigo-270d4.appspot.com",
  messagingSenderId: "764282958486",
  appId: "1:764282958486:web:421942d28a8fae7fc748b7",
  measurementId: "G-8QMKLQXZEV",
};
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const getTokenFirebase = (setTokenFound) => {
  return getToken(messaging, {
    vapidKey:
      "BL0-lOnH_9RHWEQioUyws6g_PXxCEkDaWRvjDsUxtg-JEmgGLnB83o5-Ac08nYj0EVUQ2fjk8HuqTuxhmaLVL90",
  })
    .then((currentToken) => {
      if (currentToken) {
        setTokenFound(currentToken);
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        console.log(
          "No registration token available. Request permission to generate one."
        );
        setTokenFound(false);
        // shows on the UI that permission is required
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
      // catch error while creating client token
    });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
});